import * as ngCore from '@angular/core'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import * as dynamicEcs from '../../../../dynamic-ecs'
import { Api } from '../../api.service'
import type { TypeParams } from '../../types'

import { getActionsConfig } from './actions'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * Used for a Page Builder purposes to preview selected widgets inside a grid
 */
export class Plugin extends ec.plugins.Plugin<
  TypeParams,
  typeof Plugin.id,
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  /** @see {@link ec.plugins.Plugin.Id.Custom} */
  public static id = ec.plugins.Plugin.Id.Custom.create('WidgetPreviewPlugin')

  /** @see {@link Api} */
  public readonly api: Api = ngCore.inject(Api)

  constructor({ collection }: Readonly<Plugin.constructor.Params>) {
    super({
      actions: getActionsConfig(),
      collection,
      id: Plugin.id,
      initialState: State.INITIAL,
      selectors: () => new Selectors(this),
    })

    const dynamicEcsFeature = ngCore.inject(dynamicEcs.Feature)

    this.feature.registerEffects(
      effects.getPreviewOnRequest(this),
      effects.triggerEcBootstrap(dynamicEcsFeature),
      effects.triggerEcDispose(this, dynamicEcsFeature),
    )
  }
}
export namespace Plugin {
  export namespace constructor {
    export interface Params {
      collection: ec.Collection<TypeParams>
    }
  }
}
